import React, { useEffect, useState } from 'react';
import { SSONewUserDetails } from '@99designs/apps/spa/pages/auth/SSO/common/types';
import { CookieError } from '@99designs/apps/spa/pages/auth/SSO/CookieError';
import getSSONewUserDetails from '@99designs/apps/spa/pages/auth/SSO/common/getSSONewUserDetails';

interface NewUserDetailsContextProps {
    children: (newUserDetails: SSONewUserDetails) => JSX.Element;
}

export function NewUserDetailsProvider({ children }: NewUserDetailsContextProps) {
    const [newUserDetails, setNewUserDetails] = useState<SSONewUserDetails | null>();

    useEffect(() => {
        setNewUserDetails(getSSONewUserDetails());
    }, []);

    if (typeof newUserDetails === 'undefined') {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }

    if (newUserDetails === null) {
        return <CookieError />;
    }

    return children(newUserDetails);
}
